import { Button, ButtonColor, ButtonSize } from './../../store/models/button.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ITableColumn, ITableDataSource } from 'app/store/models/table.model';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { LeftMenuService } from 'app/store/services/left-menu.service';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { SessionService } from 'app/store/services/session.service';
import { ApiDataSource } from 'app/datasources/api.datasrouce';
import { takeUntil } from 'rxjs/operators';
import { UserType } from 'app/store/models/user.model';
import { setMessagesList } from 'app/store/actions/message.action';
import { IFollowUp } from 'app/store/models/follow_up.model';
import { openDialog } from 'app/store/actions/page.action';
import { InfoTipsComponent } from 'app/dialogs/info-tips/info-tips.component';
import { environment } from '../../../environments/environment';
import { ContactsService } from 'app/store/services/contacts.service';

@Component({
  selector: 'app-removed-listing',
  templateUrl: './removed-listing.component.html',
  styleUrls: ['./removed-listing.component.scss'],
})
export class RemovedListingComponent implements OnInit, OnDestroy {
  tableDataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'action_data1',
    sortDir: 'desc',
    filters: {},
  };
  tableColumns: ITableColumn<IFollowUp>[];
  dataSource: ITableDataSource;
  exportButtonProperties: Button = {
    onClick: () => console.log('here 1 export'),
    size: ButtonSize.SMALL,
    text: 'Export',
    color: ButtonColor.ORANGE,
  };
  tableReady: boolean;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private popupShown: boolean;

  constructor(
    private http: HttpClient,
    private router: Router,
    private leftMenu: LeftMenuService,
    private store: Store<IReducers>,
    private sessionService: SessionService,
    private contactsService: ContactsService,
  ) {
    this.dataSource = new ApiDataSource<IFollowUp>(
      this.http,
      environment.apiUrl + '/v1/messages/remove',
    );
    this.exportButtonProperties.onClick = () =>
      this.contactsService.getExport('remove').subscribe((response: Blob) => {
        const dataType = response.type;
        const binaryData = [];
        binaryData.push(response);
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );

        downloadLink.setAttribute('download', 'removed.csv');
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });
    this.leftMenu.expand('inbox');
  }

  rowClass = () => ['route_message'];

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        if (sessionData.popup_tips) {
          if (this.popupShown) {
            return;
          }

          this.popupShown = true;
          this.store.dispatch(
            openDialog({
              dialogData: {
                content: InfoTipsComponent,
                title: 'Tips',
                canClose: true,
                dialogMinWidth: '700px',
                componentData: {
                  type: 'remove_popup',
                },
              },
            }),
          );
        }
        const columns: ITableColumn<IFollowUp>[] = [
          {
            id: 'contact_firstname',
            title: 'Contact',
            sortable: true,
            renderer: row => {
              return `${row.contact_firstname ? row.contact_firstname : ''} ${
                row.contact_lastname ? row.contact_lastname : ''
              }`;
            },
            route: row => this.onColumnClick(row),
          },
          {
            id: 'contact_company',
            title: 'Company',
            sortable: true,
            route: row => this.onColumnClick(row),
          },
          {
            id: 'action_date',
            title: 'Flagged Remove Date',
            sortable: true,
            route: row => this.onColumnClick(row),
            isDateColumn: true,
          },
        ];

        if (sessionData.user_type !== UserType.SINGLE_USER) {
          columns.push({
            id: 'account_firstname',
            title:
              sessionData.user_type === UserType.MASTER
                ? 'Account'
                : 'Representative',
            sortable: true,
            renderer: row => {
              return `${row.account_firstname} ${row.account_lastname}`;
            },
            route: row => this.onColumnClick(row),
          });
        }

        this.tableColumns = columns;
        this.tableReady = true;
      });
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  onColumnClick(item: IFollowUp) {
    this.router.navigate([
      '/messages/view',
      item.message_id,
      {
        from: 'remove',
      },
    ]);
  }

  onData = (items: IFollowUp[]) => {
    this.store.dispatch(
      setMessagesList({ list: items.map(item => item.message_id) }),
    );
  };
}
